import { render, staticRenderFns } from "./NewNews.vue?vue&type=template&id=588ba2de&"
import script from "./NewNews.vue?vue&type=script&lang=js&"
export * from "./NewNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports